import React from 'react';
import './RestaurantMetricCard.css';

interface RestaurantMetricCardProps {
  title: string;
  value: string;
  color?: 'default' | 'green' | 'orange' | 'gray';
}

const RestaurantMetricCard: React.FC<RestaurantMetricCardProps> = ({
  title,
  value,
  color = 'default',
}) => {
  return (
    <div className={`restaurant-metric-card metric-${color}`}>
      <h3 className="restaurant-metric-title">{title}</h3>
      <div className={`restaurant-metric-value value-${color}`}>{value}</div>
    </div>
  );
};

export default RestaurantMetricCard;

